import { IndicatorName } from '@/api/rest/resources/types/fact';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';

type GeojsonFactObject = {
  asset_id: string;
  uri: string;
  provenance: {
    description: string;
    source_dataset: string;
  };
};
type GeojsonFact = {
  grid: GeojsonFactObject;
  zonal_stats: GeojsonFactObject;
};

export const usePlotCells = () => {
  const plotFacts = usePlotFacts<GeojsonFact>([IndicatorName.habitat_intactness_geojson_urls]);
  const geojsonUrl = getFactFromFactArray<GeojsonFact>(plotFacts, IndicatorName.habitat_intactness_geojson_urls)?.value;

  return geojsonUrl?.zonal_stats?.uri ?? '';
};
